module.exports = __webpack_public_path__ + "pf.svg?2a3444886b62dd975ed8ab53da5a1730";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/pf.svg
// module id = 1157
// module chunks = 27